import React, { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Unauthorized from './pages/Unauthorized';
import Authorized from './pages/Authorized';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from './theme';
import config from './assets/config';
import { useAppDispatch, useAppSelector } from './store/reduxHooks';

export default function App() {
  const auth = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const lightThemeSelected = useAppSelector((state)=>state.ux.lightTheme)
  // const [authorized, setAuthorized] = useState<Boolean>(true);
  const [loading, setLoading] = useState<Boolean>(false);
  const [uuid, setUuid] = useState<string>(uuidv4());
  const [userCredentials, setUserCredentials] = useState<any>();
  const globalProps = useMemo(
    () => ({
      // authorized,
      loading,
      uuid,
      user: userCredentials,
      actions: {
        // authorized: {
        //   update: setAuthorized,
        //   reset: () => setAuthorized(false),
        // },
        loading: {
          update: setLoading,
          reset: () => setLoading(false),
        },
      },
    }),
    [userCredentials]
  );

  return (
    <ThemeProvider theme={lightThemeSelected ? lightTheme : darkTheme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />

      {auth.user ? (
        <Authorized {...globalProps} />
      ) : (
        <Unauthorized {...globalProps} />
      )}
    </ThemeProvider>
  );
}
